import React from 'react';
import { Helmet } from 'react-helmet-async';
import PolicyList from '../components/PolicyList';

const Policies = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <Helmet>
        <title>Threats to Democracy | Policies</title>
        <meta name="description" content="Analyze government policies and actions for threats to democratic norms and constitutional principles." />
        <link rel="canonical" href={`${window.location.origin}/p/`} />
        <meta property="og:title" content="Threats to Democracy | Policies" />
        <meta property="og:description" content="Analyze government policies and actions for threats to democratic norms and constitutional principles." />
        <meta property="og:url" content={`${window.location.origin}/p/`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${window.location.origin}/images/social-share.jpg`} />
      </Helmet>
      
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold mb-2">Threats to Democracy: Policies</h1>
        <p className="text-gray-600 max-w-3xl mx-auto">
          An analysis of government policies and actions with ratings based on their potential threats 
          to democratic norms, constitutional principles, and legal precedents.
        </p>
      </div>
      
      <PolicyList status="live" />
    </div>
  );
};

export default Policies;